'use client'

import { motion } from 'framer-motion'
import { ArrowRight, Eye, Sparkles } from 'lucide-react'
import type { StepIntroProps } from '../tipos'

export function StepIntro({ onNext, personalizacao, isFromAds }: StepIntroProps) {
  const headline = personalizacao.headline || 'Vamos criar seu site ideal?'
  const subtitle = personalizacao.subtitle || 'Responda algumas perguntas e receba uma proposta personalizada'
  const cta = personalizacao.cta || 'Comecar'

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="w-full max-w-md mx-auto text-center">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="mb-8">
        <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-purple-500 to-purple-700 flex items-center justify-center mx-auto mb-6 shadow-lg shadow-purple-500/30">
          <Eye size={32} strokeWidth={1.5} className="text-white" />
        </div>
        <h2 className="text-2xl sm:text-3xl font-semibold text-indigo-950 dark:text-white mb-3">{headline}</h2>
        <p className="text-indigo-950/50 dark:text-white/50 text-sm">{subtitle}</p>
        {isFromAds && (
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.3 }}
            className="mt-3 inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-green-500/10 border border-green-500/20 text-green-400 text-xs"
          >
            <Sparkles size={12} />
            <span>Oferta especial para voce</span>
          </motion.div>
        )}
      </motion.div>
      <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }} className="flex justify-center gap-6 mb-8">
        <div className="text-center"><div className="text-lg font-semibold text-indigo-950 dark:text-white">150+</div><div className="text-xs text-indigo-950/40 dark:text-white/40">Sites criados</div></div>
        <div className="text-center"><div className="text-lg font-semibold text-indigo-950 dark:text-white">5.0<span className="text-yellow-400 ml-1">&#9733;</span></div><div className="text-xs text-indigo-950/40 dark:text-white/40">Avaliacao</div></div>
        <div className="text-center"><div className="text-lg font-semibold text-indigo-950 dark:text-white">7</div><div className="text-xs text-indigo-950/40 dark:text-white/40">Dias</div></div>
      </motion.div>
      <motion.button initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3 }} onClick={onNext} className="group flex items-center justify-center gap-3 w-full max-w-xs mx-auto px-8 py-4 bg-purple-600 hover:bg-purple-500 active:bg-purple-700 text-white font-semibold rounded-full shadow-lg shadow-purple-500/25 transition-all active:scale-[0.98]">
        <span>{cta}</span>
        <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" />
      </motion.button>
      <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.5 }} className="mt-4 text-xs text-indigo-950/30 dark:text-white/30">Leva menos de 3 minutos</motion.p>
    </motion.div>
  )
}
